// extracted by mini-css-extract-plugin
export default {"highlight":"i4NDW__highlight"};